import { getIn, connect } from 'formik';
import PropTypes from 'prop-types';

import { AdditionalInformation } from '@hivebrite/design-system/AdditionalInformation';
import { Box } from '@hivebrite/design-system/Box';
import { FakeLink } from '@hivebrite/design-system/Link';

import { getTotalGiftsAmount } from 'hb-react/shared/apps/Donations/utils/gifts';

const ErrorMessage = (props) => {
  const { formik, onSetAmountsEqually, onUpdateGlobalAmountFromGifts } = props;
  const globalAmount = getIn(formik.values, 'donation_order[amount]');
  const gifts = getIn(formik.values, 'donation_order[gifts_attributes]');
  const totalGiftsAmount = getTotalGiftsAmount(gifts);

  // eslint-disable-next-line eqeqeq
  if (globalAmount == totalGiftsAmount) {
    return null;
  }

  return (
    <AdditionalInformation mt={4} type="info">
      <Box flexDirection="column">
        {__('This amount is different from the one you first wrote.')}
        <Box flexDirection="row" mt={3}>
          <FakeLink onClick={onUpdateGlobalAmountFromGifts}>
            {__('Keep this new amount')}
          </FakeLink>
          <FakeLink onClick={onSetAmountsEqually} ml={5}>
            {__('Go back to the first amount')}
          </FakeLink>
        </Box>
      </Box>
    </AdditionalInformation>
  );
};

ErrorMessage.propTypes = {
  onSetAmountsEqually: PropTypes.func.isRequired,
  onUpdateGlobalAmountFromGifts: PropTypes.func.isRequired,
};

export default connect(ErrorMessage);
